var map = {
	"./wedding_jun_land@2x_en-US.png": 394,
	"./wedding_jun_land@2x_ko-KR.png": 395,
	"./wedding_jun_land@2x_zh-CN.png": 396
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro ^\.\/wedding_jun_land@2x_.*\.png$
// module id = 153
// module chunks = 0